import OrderOptimizerDetailsCargoRequest from "../../../../api/raily/order-optimizer/details/cargo/order-optimizer-details-cargo.request";
import OrderOptimizerDetailsCargoParams from "./order-optimizer-details-cargo-params";

const create = (
  params: OrderOptimizerDetailsCargoParams,
): OrderOptimizerDetailsCargoRequest => {
  return {
    optimizationId: params.optimizationId,
    taxiDriverAssociationId: params.taxiDriverAssociationId,
    excludedOrders: params.excludedOrders,
  };
};

const orderOptimizerDetailsCargoParamsFactory = {
  create,
};

export default orderOptimizerDetailsCargoParamsFactory;
